import { State } from 'src/types'
import { edgeOfCommon, edgeOfRegularBackStyle } from '../edge'
import { hamidashiOfMiddleFingerRegularBackStyle } from '../hamidashi'
import { indexFingerTipOutDrawer } from '../indexFingerTipOut'
import { littleFingerOfRegularBackStyle } from '../littleFinger'
import { regularBackStyleWristBelt } from '../regularBackWristBelt'
import { ringRightMiddleLeftFingerOfRegularBackStyle } from '../ringMiddleFinger'
import { thumbFingerOfRegularBackStyle } from '../thumbFinger'

export const regularStyleDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const isRegularBack =
    [state?.baseModel?.backStyle, state?.backStyle?.value].includes('regularBackStyleCatcher') &&
    state?.baseModel?.backStyle !== 'beltBackStyleCatcher' &&
    state?.backStyle?.value !== 'beltBackStyleCatcher'
  if (!isRegularBack) return
  // 親指
  // 人差指
  // 中指右
  thumbFingerOfRegularBackStyle(ctx, state?.thumbIndexMiddleRight?.color, state.stitch.color)
  // 中指左
  // 薬指
  ringRightMiddleLeftFingerOfRegularBackStyle(ctx, state?.middleLeftRing?.color, state.stitch.color)
  // 小指袋
  littleFingerOfRegularBackStyle(ctx, state.littleOut.color, state.stitch.color)
  // ハミダシ
  hamidashiOfMiddleFingerRegularBackStyle(ctx, state.hamidashi)
  // ヘリ革
  edgeOfCommon(ctx, state.edge.color)
  edgeOfRegularBackStyle(ctx, state.edge.color, state.fingerGuardType.value, state.linings.color)
  // 人差し指の指だし周りパーツ部分
  indexFingerTipOutDrawer(ctx, state?.indexFingerTipOut?.color, state.fingerGuardType.value)
  // バックルベルト
  regularBackStyleWristBelt(ctx, state.listBelt.color, -70, 50)
}
